import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import moment from "moment/moment";
import axiosInstance from "../../../axios";
import { Loading } from "../../Other/Loading";

const Subscription = () => {
  const { loggedIn } = useSelector((state) => state.authentication);
  const [subscriptionDetails, setSubscriptionDetails] = useState();
  const [response, setResponse] = useState();

  useEffect(() => {
    if (loggedIn) {
      setResponse(true);
      axiosInstance
        .get("/current-subscription")
        .then((res) => {
          setSubscriptionDetails(res?.data?.data);
          setResponse(false);
        })
        .catch((res) => console.log(res));
    }
  }, [loggedIn]);

  return (
    <>
      <section className="container-wrapper">
        {response ? (
          <Loading />
        ) : (
          <div
            className="main studentPurchase"
            style={{ height: "auto", border: "1px solid black" }}
          >
            <div className="content">
              <div className="content-inner">
                <div className="inner-top">
                  <div className="inner-top-flex plan-Details">
                    <div className="right studentname webinarDetails plan_header">
                      <h3>Plan Info</h3>
                    </div>
                  </div>
                  <div className="plan-flex">
                    <div className="inner-top-flex plan-Details">
                      <div
                        className="right studentname webinarDetails"
                        style={{ color: "#7108b9" }}
                      >
                        <span> Plan Name:</span>{" "}
                        {subscriptionDetails?.planInfo?.name}
                      </div>
                    </div>
                    <div className="inner-top-flex plan-Details">
                      <p
                        className="courseNameResponsive webinarDetails"
                        style={{ color: "#7108b9" }}
                      >
                        <span>Plan Value :</span>{" "}
                        {subscriptionDetails?.planInfo?.amount}
                      </p>
                    </div>

                    <div className="inner-top-flex plan-Details">
                      <p
                        className="courseNameResponsiveAgain webinarDetails"
                        style={{ color: "#7108b9" }}
                      >
                        <span> Trial Period Days:</span>{" "}
                        {subscriptionDetails?.planInfo?.trialDays}
                      </p>
                    </div>
                    <div className="inner-top-flex plan-Details">
                      <p
                        className="courseNameResponsiveAgain webinarDetails"
                        style={{ color: "#7108b9" }}
                      >
                        <span> Trail Period Starts On : </span>

                        {moment(
                          subscriptionDetails?.subscribed?.startOn
                        ).format("MMM DD, YYYY")}
                      </p>
                    </div>
                    <div className="inner-top-flex plan-Details">
                      <p
                        className="courseNameResponsiveAgain webinarDetails"
                        style={{ color: "#7108b9" }}
                      >
                        <span> Trial Period End On : </span>
                        {moment(
                          subscriptionDetails?.subscribed?.trialEndOn
                        ).format("MMM DD, YYYY")}
                      </p>
                    </div>

                    <div className="inner-top-flex plan-Details">
                      <p
                        className="courseNameResponsiveAgain webinarDetails"
                        style={{ color: "#7108b9" }}
                      >
                        <span> Remaining Credits:</span>
                        {subscriptionDetails?.subscribed?.availableCredit.toFixed(
                          2
                        )}
                      </p>
                    </div>

                    <div className="inner-top-flex plan-Details">
                      <p
                        className="courseNameResponsiveAgain webinarDetails"
                        style={{ color: "#7108b9" }}
                      >
                        <span> Remaining Days:</span>{" "}
                        {subscriptionDetails?.remainingDays}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
};
export default Subscription;
